function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCsaSnapshot = function SvgCsaSnapshot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.414,
    height: 21.369,
    viewBox: "0 0 18.414 21.369",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 201",
    d: "M9.5 1 18 6M9.5 1l1.916 8.048M9.5 1 5.25 3.5 1 6m17 0v10m0-10-5.882 5.715M18 16l-8.5 5m8.5-5-7.8-2.333M9.5 21 1 16m8.5 5-1.916-8.047M1 16V6m0 10 5.882-5.715M1 6l7.8 2.333m0 0 2.618.715M8.8 8.333l-1.918 1.952m4.534-1.238.7 2.667m0 0L10.2 13.667m0 0-2.618-.715m0 0-.7-2.667",
    transform: "translate(-.293 -.316)",
    style: {
      fill: "none",
      stroke: "#889ccc",
      strokeLinecap: "round"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCsaSnapshot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/csaSnapshot.d2358e1f.svg";
export { ForwardRef as ReactComponent };